import { initTabs } from "./_tabs.js";
import { executeCalculation } from "./_calculation.js";
import { hasInitialValues } from "./_input.js";
import { getAllElements, createContext } from "./_dom.js";

/**
 * メイン処理
 */
const main = () => {
    const elements = getAllElements();
    if (!elements.pgHead) return;

    // タブ切り替えの初期化
    initTabs();

    let currentType = elements.pgHead.dataset.type;
    if (!currentType || (currentType !== "house" && currentType !== "land")) {
        currentType = "house";
    }

    // コンテキストオブジェクトを作成
    const context = createContext(currentType, elements.resultElement);

    // 初期値がある場合は計算を実行
    if (hasInitialValues(currentType, context.inputs)) {
        executeCalculation(currentType, context);
    }
};

export default main;
